
import { Vue, Component } from "vue-property-decorator";
import LoginForm from "@/modules/login/components/LoginForm.vue";
import LinkBtn from "@/components/common/LinkBtn.vue";

@Component({
  components: { LinkBtn, LoginForm },
})
export default class LoginIndex extends Vue {}
